export default "__VITE_ASSET__CYTIWmvG__"